import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { capitalize } from "features/User/utils"
import "../EtapasList/style.scss"

function EtapasElement({
  etapa,
  handleRemove,
  orden,
  handleCount,
}: $TSMigrationFixMe) {
  return (
    <div className='board-item'>
      <div className='board-item_data-content'>
        <FontAwesomeIcon icon={["fal", "grip-dots-vertical"]} />
        <span className='order-label'>{orden}</span>
        <span className='name-label'>
          {capitalize(etapa.departamentoNombre?.toLowerCase())}
        </span>
      </div>
      <div className='board-element-text-signs_content'>
        {/* TODO: i18n */}
        <h6>Firmas</h6>
        <div className='board-element_icons-content'>
          <FontAwesomeIcon
            icon={["fas", "minus"]}
            onClick={() => handleCount(etapa.departamentoId, -1)}
          />
          <span>{etapa.numeroFirmas}</span>
          <FontAwesomeIcon
            icon={["fas", "plus"]}
            onClick={() => handleCount(etapa.departamentoId, +1)}
          />
        </div>
        <FontAwesomeIcon
          icon={["fal", "xmark"]}
          className='icon-delete'
          onClick={() => handleRemove(etapa.departamentoId)}
        />
      </div>
    </div>
  )
}

export default EtapasElement
